import React, { PureComponent, Fragment } from "react";
import styled from "styled-components";
import { withRouteData } from "react-static";

import HeroSection from "./HeroSection";
import ServicesSection from "./ServicesSection";
import LocalSection from "./LocalSection";
import FooterSection from "./FooterSection";

const Site = styled.div`
  font-size: 15px;
  position: relative;

  @media (max-width: 1810px) {
    font-size: 10px;
  }

  @media (max-width: 1337px) {
    font-size: 8.5px;
  }
`;

export default withRouteData(({ cms }) => (
  <Site>
    <HeroSection cms={cms} />
    <ServicesSection cms={cms} />
    <LocalSection cms={cms} />
    <FooterSection cms={cms} />
  </Site>
));



// WEBPACK FOOTER //
// /opt/build/repo/src/pages/Landing/LandingPage.js